import { CHECKS_SCHEMA } from '../schema';

export const LATENCY_TABLE_NAME = 'latency';

export const CREATE_TABLE_SQL = `CREATE TABLE ${CHECKS_SCHEMA}.${LATENCY_TABLE_NAME} (
  time                   TIMESTAMPTZ          NOT NULL       DEFAULT NOW(),
  user_id                UUID                 NOT NULL,
  monitor_id             UUID                 NOT NULL,
  region                 TEXT                 NOT NULL,
  status                 SMALLINT             NOT NULL,
  error                  TEXT                 NULL,
  total_time             REAL                 NULL,
  tls_handshake_time     REAL                 NULL,
  tcp_connection_time    REAL                 NULL,
  dns_lookup_time        REAL                 NULL,
  first_byte_time        REAL                 NULL,
  blob_size              REAL                 NULL
);`;

export const CREATE_HYPERTABLE_SQL = `SELECT create_hypertable('${CHECKS_SCHEMA}.${LATENCY_TABLE_NAME}', 'time');`;
